import * as React from 'react';
import {AppLogo} from '@openfin/desktop-ui';

import {Entity, App} from '../../../types/commons';
import * as OpenfinIcon from '../../../assets/Logo.svg';
import {ApplicationPin} from '../ApplicationPin/ApplicationPin';
import {isOmnibar} from '../../../utils/processHelpers';

import * as Styles from './EntityDetailTile.module.scss';

interface EntityDetailTileProps {
    entity?: Entity;
    emptyDescription: string;
}

export const EntityDetailTile: React.FC<EntityDetailTileProps> = (props) => {
    const {entity, emptyDescription} = props;

    const isApp = (app: Entity): app is App => {
        // Check for some required property that exists on one type but not the other
        return app.hasOwnProperty('id');
    };

    const hasTags = entity && isApp(entity) && entity.tags && entity.tags.length > 0;

    return (
        <div className={Styles['entity-detail-tile']}>
            <AppLogo src={entity ? entity.icon : OpenfinIcon} className={Styles['icon']} />
            {!isOmnibar() && entity && isApp(entity) && <div className={Styles['buttons']}>
                <ApplicationPin app={entity} />
            </div>}
            <div className={Styles['title']}>
                {entity && entity.title}
            </div>
            {
                hasTags && <div className={Styles['tags']}>
                    {
                        (entity as App).tags!.filter((tag) => !!tag).map((tag) => `#${tag.name}`).join(' ')
                    }
                </div>
            }
            <div className={Styles['description']}>
                {entity ? entity.description : emptyDescription}
            </div>
        </div>
    );
};

